<bn-loading-overlay></bn-loading-overlay>


<h5>Avisos</h5>
<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto" *ngIf="podeCadastrarAviso">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/avisos']" 
          ngbTooltip="Tela para cadastro de aviso."><i class="fa fa-file-signature">
          </i> Cadastrar Novo Aviso</button>
      </div>         
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>      
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
          [disabled]="!pesquisaForm.valid" >Pesquisar</button>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="mb-3 col-md-7">
          <label class="form-label"  for="agenteFinanceiro">Agente Financeiro Destinatário:</label>
          <select  id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
            <option [ngValue]=null>Todos</option>
            <option *ngFor="let item of agentesFinanceiros" 
                    [ngValue]="item">{{ item.nome }}</option>
          </select>  
      </div>
      <div class="mb-3 col-md-5">
        <label class="form-label" for="tipo">Tipo: </label>
        <select id="tipo" class="form-select" [compareWith]="compararPorId" formControlName="tipo">
          <option [ngValue]=null>Todos</option>
          <option [ngValue]="tipoAviso.codigo" *ngFor="let tipoAviso of tiposAviso" >{{ tipoAviso.label }}</option>
        </select>
      </div>      
    </div>

    <div class="mb-3 row">
      <div class="mb-3 col-md-2" *ngIf="!perfilAgente">
        <label class="form-label"  for="situacao">Situação: </label>
        <select id="situacao" class="form-select" formControlName="situacao">
          <option value="T">Todas</option>
          <option value="A">Ativo</option>
          <option value="D">Desativado</option>
        </select>
      </div> 

      <div class="mb-3" [ngClass]="{'col-md-10': !perfilAgente, 'col-md-12': perfilAgente}">
        <label class="form-label"  for="titulo">Título:</label>
        <input class="form-control" formControlName="titulo">
      </div>

      <div class="mb-3 col-md-3">
        <label class="form-label"  for="dataCriacaoInicial">Data de publicação inicial:</label>
        <bn-datepicker name="dataCriacaoInicial" idInput="dataCriacaoInicial" formControlName="dataCriacaoInicial"></bn-datepicker>
      </div>

      <div class="mb-3 col-md-3">
        <label class="form-label"  for="dataCriacaoFinal">Data de publicação final:</label>
        <bn-datepicker name="dataCriacaoFinal" idInput="dataCriacaoFinal" formControlName="dataCriacaoFinal">
        </bn-datepicker>
      </div>

      <div class="mb-3 col-md-3" *ngIf="!perfilAgente">
        <label class="form-label"  for="dataDesativacaoInicial">Data de desativação inicial:</label>
        <bn-datepicker name="dataDesativacaoInicial" idInput="dataDesativacaoInicial" formControlName="dataDesativacaoInicial" >
        </bn-datepicker>
      </div>

      <div class="mb-3 col-md-3" *ngIf="!perfilAgente">
        <label class="form-label"  for="dataDesativacaoFinal">Data de desativação final:</label>
        <bn-datepicker name="dataDesativacaoFinal" idInput="dataDesativacaoFinal" formControlName="dataDesativacaoFinal">
        </bn-datepicker>
      </div>            
    </div>
  </form>
</div>

<ng-template #desativacao>
    <h5>Deseja realmente desativar o aviso abaixo descrito ?</h5>
    <div class="row">
      <div class="mb-3 col-md-12">
        <label for="tituloAviso"><b>Título</b></label>
        <input readonly type="text" class="form-control" id="tituloAviso" name="tituloAviso" value="{{avisoDesativando.titulo}}" />
      </div>
    </div>
    <div class="row">
      <div class="mb-3 col-md-6"> 
        <label for="tipo"><b>Destinatário</b></label>
        <input readonly type="text" class="form-control" id="destinatario" name="destinatario" value="{{nomeAgente(avisoDesativando.agenteFinanceiroDestinatario)}}"/>
      </div>  
      <div class="mb-3 col-md-3"> 
        <label for="dataPublicacao"><b>Publicado em</b></label>
        <input readonly type="text" class="form-control" id="dataPublicacao" name="dataPublicacao" value="{{avisoDesativando.dataCriacao | date: 'dd/MM/yyyy HH:mm'}}"/>
      </div>  
      <div class="mb-3 col-md-3">
        <label class="color-red" for="dataDesativacao"><b>Desativando em</b></label>
        <input readonly type="text" class="form-control" id="dataDesativacao" name="dataDesativacao" value="{{avisoDesativando.dataDesativacao | date: 'dd/MM/yyyy HH:mm'}}"/>
      </div>      
    </div>
</ng-template>

<ng-template #desativacaoBotoes >
    <button class="btn btn-default" (click)="cancelaDesativacao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmaDesativacao()">Confirmar</button>
</ng-template>

<app-aviso-listagem
  [avisos]="avisos"
  [podeCadastrarAviso]="podeCadastrarAviso"
  [perfilAgente]="perfilAgente"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  *ngIf="pesquisado"
  [hidden] = "mostrarPesquisa"
  (aoRequererDesativacao)="desativacaoAviso($event)"
  (aoMudarPagina)="mudancaPagina($event)"
  (exportarAvisos)="exportarAvisos()">
</app-aviso-listagem>